module.exports = __webpack_public_path__ + "656b84a667af9d7bd24dad14415b88e2.jpg";